// @to/vendor — shared vendor directory module
export {
  SearchBar,
  VendorCard,
  VendorListItem,
  VendorFilterSidebar,
  VendorSearchResults,
  VendorResultImpressions,
  SortDropdown,
  Icon,
  PromotionCard,
} from './components';

export type {
  SearchBarProps,
  VendorCardProps,
  VendorCardVendor,
  VendorListItemProps,
  VendorListItemVendor,
  VendorBadge,
  VendorFilterSidebarProps,
  VendorSearchResultsProps,
  VendorAugmentation,
  SortDropdownProps,
  SortOption,
  PromotionCardProps,
  PromotionCardOffer,
} from './components';

// Hooks
export { useTrackInView } from './hooks/useTrackInView';
export type { UseTrackInViewOptions } from './hooks/useTrackInView';

// VBC detail components
export {
  VBCHero,
  VBCTrustBadges,
  VBCAbout,
  VBCCategories,
  VBCLocations,
  VBCCredentials,
  VBCSpecialOffers,
  VBCContactBar,
  VBCContactActions,
  VBCContactInfo,
  VBCSaveButton,
  VBCShareButton,
  VBCInquiryForm,
  VBCQRCode,
  VendorDetailPage,
} from './components';

export type {
  VBCHeroProps,
  VBCTrustBadgesProps,
  RenderedTrustBadge,
  VBCAboutProps,
  VBCCategoriesProps,
  CategoryItem,
  VBCLocationsProps,
  ServiceArea,
  VBCCredentialsProps,
  VBCSpecialOffersProps,
  SpecialOfferItem,
  VBCContactBarProps,
  VBCContactActionsProps,
  VBCContactInfoProps,
  VBCSaveButtonProps,
  VBCShareButtonProps,
  VBCInquiryFormProps,
  InquiryFormData,
  VBCQRCodeProps,
  VendorDetailPageProps,
  VendorDetailVendor,
} from './components';

// vCard 3.0 builders — used by both apps' vCard endpoints AND their vendor
// detail page server components (which embed the vCard text directly in the
// QR code via VBCQRCode).
export { buildVCardString, escapeVCardValue } from './vcard';
export type { VCardVendor } from './vcard';
